import Link from 'next/link';
import { MessageCircle, MapPin, Calendar, Users } from 'lucide-react';

export function CustomTripCTA() {
  return (
    <section className="bg-gradient-to-br from-amber-50 via-orange-50 to-red-50 py-16 px-4">
      <div className="container mx-auto max-w-4xl">
        <div className="text-center mb-10">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            Dream Up Your Own Adventure
          </h2>
          <p className="text-lg text-gray-700 max-w-2xl mx-auto">
            Don't see exactly what you're looking for? Let's plan a custom trip tailored to your group's interests,
            fitness level, and schedule. From weekend getaways to week-long expeditions, I'll help you create
            the perfect backcountry experience.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-6 mb-10">
          <div className="bg-white rounded-lg p-6 shadow-sm">
            <MapPin className="h-8 w-8 text-terracotta mb-3" />
            <h3 className="font-semibold text-gray-900 mb-2">Choose Your Destination</h3>
            <p className="text-gray-600 text-sm">
              Pick from Arizona's diverse landscapes, the Pacific Northwest, or suggest your own dream location
            </p>
          </div>

          <div className="bg-white rounded-lg p-6 shadow-sm">
            <Calendar className="h-8 w-8 text-terracotta mb-3" />
            <h3 className="font-semibold text-gray-900 mb-2">Flexible Scheduling</h3>
            <p className="text-gray-600 text-sm">
              Day hikes, weekend trips, or extended expeditions - we'll design the perfect itinerary for your timeline
            </p>
          </div>

          <div className="bg-white rounded-lg p-6 shadow-sm">
            <Users className="h-8 w-8 text-terracotta mb-3" />
            <h3 className="font-semibold text-gray-900 mb-2">Any Skill Level</h3>
            <p className="text-gray-600 text-sm">
              Whether you're a first-timer or experienced backpacker, I'll match the difficulty to your group
            </p>
          </div>

          <div className="bg-white rounded-lg p-6 shadow-sm">
            <MessageCircle className="h-8 w-8 text-terracotta mb-3" />
            <h3 className="font-semibold text-gray-900 mb-2">Personal Planning</h3>
            <p className="text-gray-600 text-sm">
              Work directly with me to design every detail - from route selection to gear recommendations
            </p>
          </div>
        </div>

        <div className="text-center">
          <Link
            href="/contact"
            className="inline-flex items-center gap-2 bg-terracotta text-white px-8 py-4 rounded-lg
                     hover:bg-terracotta/90 transition-colors text-lg font-semibold shadow-lg
                     hover:shadow-xl transform hover:-translate-y-0.5 transition-all"
          >
            <MessageCircle className="h-5 w-5" />
            Plan My Custom Trip
          </Link>
          <p className="mt-4 text-sm text-gray-600">
            Response within 24 hours • Free consultation • No commitment required
          </p>
        </div>
      </div>
    </section>
  );
}
